export default __webpack_public_path__ + "static/media/ipCamera.861916a3.png";